<template>
  <v-app>
    <user-core-drawer />

    <user-core-view />

    <vue-confirm-dialog></vue-confirm-dialog>

  </v-app>
</template>

<script>
export default {
  name: "Index",
  components: {
    UserCoreDrawer: () => import("./core/Drawer"),
    UserCoreView: () => import("./core/View"),
  }
,



};
</script>